import {requestContext} from '../../../../common/requestContext';
import {twMerge} from '../../../../common/twMerge';
import {Grid} from '../../../../design-system/atoms/Grid/Grid';
import {SectionType} from '../../../../graphql/generated/types';
import {useGetParentSection} from '../../../../pagewebLayout/useGetParentSection';
import {CommonGroupProps} from '../../type';

function StrategyCategory({group, children}: CommonGroupProps) {
  const {isMobile} = requestContext.requestInfo.display;
  const parentSection = useGetParentSection(group.id);
  return (
    <div>
      <Grid
        className={twMerge(
          'overflow-hidden rounded-3pxr',
          parentSection.type === SectionType.Top && 'mt-15pxr',
          parentSection.type === SectionType.Top && isMobile && 'mt-8pxr'
        )}
        cols={3}
        gapPx={0}
      >
        {children}
      </Grid>
    </div>
  );
}

export default StrategyCategory;
